// @flow
import data from '../../data/ProductType';

type Product = { id: string, id: string, route: string };
type ProductType = Product & { sizes: Array<Product> };

function reducer(key, sizePrefix = '') {
  return (acc, [id, prod]) => {
    const product = ((prod: any): ProductType);
    const accessor = key === 'id' ? id : product[key];
    const { route, sizes } = product;
    const sizeMap = sizes.reduce(
      (sizeAcc, size) => ({
        ...sizeAcc,
        [`${sizePrefix}${size[key]}`]: { productId: id, productRoute: route, ...size },
      }),
      {},
    );
    return { ...acc, ...sizeMap, [accessor]: { ...product, id } };
  };
}

const productTypeKeys = Object.entries(data);
const sizePrefix = 'size_';
const idDictionary = productTypeKeys.reduce(reducer('id', sizePrefix), {});
const routesDictionary = productTypeKeys.reduce(reducer('route'), {});

type ProductId = string; // $Keys<typeof idDictionary>;
type ProductRoute = string; // $Keys<typeof routesDictionary>;

export const defaultProductRoute = 'all';

export const getProductRouteById = (id: ProductId) => idDictionary[id]?.route ?? defaultProductRoute;

export const getProductSizeRouteById = (id: ProductId) =>
  idDictionary[`${sizePrefix}${id}`]?.route ?? defaultProductRoute;

export const getProductIdByRoute = (route: ProductRoute) => routesDictionary[route]?.id ?? defaultProductRoute;

export const isValidProductSizeRoute = (productId: ProductId, route: ProductRoute) =>
  routesDictionary[route]?.productId === productId;

export const isValidProductTypeRoute = (route: ProductRoute) => {
  const product = routesDictionary[route];
  const isAll = route === defaultProductRoute;
  const isNotSubRoute = !product?.productId;
  return isAll || !!(product && isNotSubRoute);
};

export const getUrlPathByProductRoute = (route: ProductRoute) => {
  const validRoute = getProductIdByRoute(route) ?? defaultProductRoute;
  return `/products/${validRoute}`;
};
